import React, { useEffect } from 'react'

const Editsms = () => {
   
    return (
        <div>
            <div className="modal fade" id="EditsmsModal" tabindex="-1" aria-labelledby="EditsmsModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header" >
                            <h5 className="modal-title font-bold" id="EditsmsModalLabel">Edit SMS Template </h5>
                            <button type="button" className="btn-close btn-close-primary size-10" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="first-section">
                                <div className="row mb-3">
                                    <div className="col-md-4 ">
                                        <label htmlFor="response" className="form-label">Project (*)</label>
                                        <select className="form-select" id="response">
                                            <option value="" disabled selected>Select</option>
                                            <option value="NOT INTERESTED">REAl DO</option>
                                            <option value="SAI Branding">SAI Branding</option>

                                            {/* Add other options here */}
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label for="title" className="form-label">Title (*)</label>
                                        <input type="text" className="form-control" id="title" placeholder="Enter title" />
                                    </div>
                                    <div className="col-md-4 ">
                                        <label htmlFor="response" className="form-label">Types (*)</label>
                                        <select className="form-select" id="response">
                                            <option value="" disabled selected>Select</option>
                                            <option value="Lead">Lead</option>
                                            <option value="Client">Client</option>
                                            <option value="Property">Property</option>
                                            <option value="Broker">Broker</option>

                                            {/* Add other options here */}
                                        </select>
                                    </div>
                                  
                                    <div className="col-12 mt-3">
                                        <label for="remarks" className="form-label">Remarks (*)</label>
                                        <textarea className="form-control" id="remarks" rows="3"></textarea>
                                    </div>
                                </div>

                            </div>


                        </div>
                        <div className="modal-footer justify-content-between p-3" style={{ borderTop: "2px solid #f0f0f0" }}>
                            <button
                                type="button"
                                className="btn btn-outline-primary d-flex align-items-center gap-2"
                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem" }}
                                data-bs-dismiss="modal"
                            >
                                <i className="bi bi-x-circle"></i> Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-gradient d-flex align-items-center gap-2"

                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem", background: "linear-gradient(90deg, #6a11cb 0%, #313265 100%)", color: "white", border: "none" }}
                            >
                                <i className="bi bi-plus-circle"></i>  Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Editsms

